// extracted by mini-css-extract-plugin
export default {"BreadcrumbMainDiv":"CustomBreadCrumb_BreadcrumbMainDiv__yXKUM"};